import React, { useState } from "react";
import PropTypes from "prop-types";
import { constant } from "../../../../shared/constant";

function TotalAccuracyTable({ tableData }) {
  const [state, setState] = useState();
  return (
    <div className="container-fluid">
      <h3 className="table-title text-center">Total Accuracy</h3>
      <div className="homepitchers-table">
        <div className="table-responsive-xl">
          <table className="table tabledashed">
            <thead>
              <tr>
                <th className="tablerowblue fw-500">Pitch Type</th>
                <th className="tablerowblue fw-500">Total Calls</th>
                <th className="tablerowblue fw-500">Misses</th>
                <th className="tablerowblue fw-500">Accuracy</th>
              </tr>
            </thead>
            <tbody>
              {
                tableData && tableData.length !== 0 ?
                  tableData.map(_ => {
                    const rowColor = _._id === "Total" ? "table-rowgrey80" : "table-rowwhite"
                    return (
                      <tr>
                        <td className={`${rowColor}`} style={{ color: constant.pitchTypeColor[_._id] }}>{_ && _._id}</td>
                        <td className={`${rowColor}`}>{_ && _.pitches}</td>
                        <td className={`${rowColor}`}>{_ && _.missed}</td>
                        <td className={`${rowColor}`}>{_ && _.accuracy && _.accuracy.toFixed(1) + "%"}</td>
                      </tr>
                    )
                  })
                  :
                  <tr>
                    <td className="table-rowwhite text-center" colSpan="4">There's no info yet!</td>
                  </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

TotalAccuracyTable.propTypes = {};

export default TotalAccuracyTable;
